export const Breakpoints = {
  None: 0,
  S: 600,
  M: 840,
  L: 1024,
  XL: 1280
} as const;

export type BreakpointKey = keyof typeof Breakpoints;

export const minWidth = {
  None: `(min-width: ${Breakpoints.None}px)`,
  S: `(min-width: ${Breakpoints.S}px)`,
  M: `(min-width: ${Breakpoints.M}px)`,
  L: `(min-width: ${Breakpoints.L}px)`,
  XL: `(min-width: ${Breakpoints.XL}px)`
} as const;

export const maxWidth = {
  S: `(max-width: ${Breakpoints.S - 1}px)`,
  M: `(max-width: ${Breakpoints.M - 1}px)`,
  L: `(max-width: ${Breakpoints.L - 1}px)`,
  XL: `(max-width: ${Breakpoints.XL - 1}px)`
} as const;
